import { reducers } from './reducers';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { QuoteInformationState } from './types';

export const initialState: QuoteInformationState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'quoteInformation',
  initialState,
  reducers,
});

export const { actions: quoteInformationActions } = slice;
export const { reducer: quoteInformationReducer } = slice;
